import { Component } from '@angular/core';

@Component({
  selector: 'ui-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
}
